import { CAN_STOP_STATUSES } from '../../../config/studyCard';
import type { Study } from './studyCard.types';

/**
 * Reports whether the study card's stop action must stay disabled. Treats stopping as allowed only while lastStudyHistory.status is one of CAN_STOP_STATUSES and the study is not already stopping, then returns the negation.
 *
 * @param study - Study whose last history status and stopping flag are checked.
 * @returns True when the study cannot be stopped.
 */
const isCheckCanStopStudy = (study: Study) => {
  const { lastStudyHistory } = study || {};
  const canStop = CAN_STOP_STATUSES.includes(lastStudyHistory?.status) && !study.isStopping;
  return !canStop;
};

export { isCheckCanStopStudy };
